import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollBalloonClass {
  constructor(elms) {
    this.dom = {elms: elms};
    this.dom.footer = document.querySelector('[data-js="hero-footer"]');
    
    this.footerH = Math.floor(this.dom.footer.getBoundingClientRect().height);
    this.ww = window.innerWidth;
    this.wh = window.innerHeight;

    if (this.ww < 768) {
      this.start = 100 - Math.floor(((this.wh - this.footerH + 50) / this.wh) * 100);
    } else {
      this.start = 100 - Math.floor(((this.wh - this.footerH + 100) / this.wh) * 100);
    }

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    [...this.dom.elms].forEach((el, index) => {
      ScrollTrigger.create({
        trigger: el,
        id: index + 1,
        start: `bottom bottom-=${this.start}%`,
        end: 'bottom 10%',
        toggleClass: {
          targets: el,
          className: 'is-show'
        },
        once: false,
        // markers: true,
      });
    });
  }
}

export default ScrollBalloonClass